import { Http, PageData, PageQuery } from '@mygpt/app';

export interface GetMetricsParams extends PageQuery {
  robot_id: string;
  start_date: string;
  end_date: string;
}
export interface MetricsItem {
  id: string;
  created_at: string;
  updated_at: string;
  hour_of_day: number;
  created_session_count: number;
  message_count: number;
  like_count: number;
  dislike_count: number;
  new_users: string[] | null;
  old_users: string[] | null;
}
export interface MetricsPageItem {
  message_count: number;
  message_proportion: number;
  url: string;
  title: string;
}
export interface PostMetricsParams {
  robot_id: string;
  title: string;
  url: string;
}
export interface MetricsSuccess {
  id: string;
  created_at: string;
  updated_at: string;
  title: string;
  url: string;
}

export interface GetMetricsMessageParams {
  robot_id: string;
  page: number;
  size: number;
  start_date?: string;
  end_date?: string;
}

export interface MetricsMessageItem {
  day: string;
  count: number;
  consumed: number;
}

export interface GetMetricsMessageDetailParams {
  robot_id: string;
  day: string;
}

export interface MetricsMessageDetailItem {
  id: string;
  created_at: string;
  session_id: string;
  question: string;
  consumed: number;
}

/**
 * 获取仪表板数据
 * @param params
 * @returns
 */

export const getMetrics = (params: GetMetricsParams) => {
  const { robot_id, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<MetricsItem>>(`/session/metrics/${robot_id}`, {
    params: rest,
  });
};

/**
 * 记录问答当前页面数据
 * @param params
 * @returns
 */
export const postMetricsView = (params: PostMetricsParams) => {
  const { robot_id, ...rest } = params;
  const { post } = Http.use();
  return post<MetricsSuccess>(`/session/metrics/${robot_id}/view`, rest);
};

/**
 * 获取问答页面记录数据
 * @param params
 * @returns
 */
export const getMetricsPage = (params: GetMetricsParams) => {
  const { robot_id, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<MetricsPageItem>>(`/session/metrics/${robot_id}/page`, {
    params: rest,
  });
};

/**
 * 获取消息消耗日志
 */
export const getMetricsMessage = (params: GetMetricsMessageParams) => {
  const { robot_id, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<MetricsMessageItem>>(`/session/metrics/${robot_id}/message/day/count`, {
    params: rest,
  });
};

/**
 * 获取某一天消息消耗详细
 */
export const getMetricsMessageDetail = (params: GetMetricsMessageDetailParams) => {
  const { robot_id, ...rest } = params;
  const { get } = Http.use();
  return get<MetricsMessageDetailItem[]>(`/session/metrics/${robot_id}/message/day/info`, {
    params: rest,
  });
};
